import React from "react";
import { AFFILIATIONS } from "@/data/site";
import { useT } from "@/i18n/LanguageContext";

export default function Affiliations() {
  const { t } = useT();
  return (
    <section
      data-testid="affiliations-strip"
      className="px-6 md:px-10 lg:px-16 border-y border-[var(--border)] bg-[var(--surface)] py-8"
    >
      <div className="flex flex-wrap items-center justify-center gap-8 md:gap-16">
        <p className="font-mono-eyebrow text-[var(--text-muted)] text-center md:text-left">
          {t("Proud members of")}
        </p>
        {AFFILIATIONS.map((a) => (
          <a
            key={a.short}
            data-testid={`affiliation-${a.short.toLowerCase()}`}
            href={a.url}
            target="_blank"
            rel="noreferrer"
            className="flex items-center gap-3 group"
            title={a.label}
          >
            <img
              src={a.logo}
              alt={a.label}
              className="h-12 md:h-14 w-auto opacity-80 group-hover:opacity-100 transition"
              loading="lazy"
            />
          </a>
        ))}
        <p className="text-xs uppercase tracking-[0.22em] text-[var(--text-muted)] text-center">
          {t("Multilingual team · English · French · Farsi · Spanish")}
        </p>
      </div>
    </section>
  );
}
